import { render, staticRenderFns } from "./State.vue?vue&type=template&id=10127cc7&scoped=true&"
import script from "./State.vue?vue&type=script&lang=js&"
export * from "./State.vue?vue&type=script&lang=js&"
import style0 from "./State.vue?vue&type=style&index=0&id=10127cc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10127cc7",
  null
  
)

export default component.exports